import { FormattedMessage } from 'react-intl'

import { Badge, Typography } from '@/shared/ui'

export const OwnerRoleCell = () => {
  return (
    <div className="flex items-center">
      <Badge variant="neutral" className="capitalize">
        <Typography bold variant="body-small">
          <FormattedMessage
            id="individual.role.label"
            defaultMessage="{role, select, LEGAL_REPRESENTATIVE {Legal rep.} BENEFICIAL_OWNER {Owner} other {}}"
            values={{ role: 'BENEFICIAL_OWNER' }}
          />
        </Typography>
      </Badge>
    </div>
  )
}
